import type { TableConstants } from './common';

const commonTableConstants: TableConstants = {
    borderWidth: 2,
    borderColor: '#b4b8bfff',
    cellWidth: 218,
    cellHeight: 120,
};

export default commonTableConstants;
